import { createSpinner } from "./createSpinner";

export const Spinner = createSpinner({});
